module.exports = __webpack_public_path__ + "img/Modou.5be7ac01.png";